import type { ReactNode } from 'react';
import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import { cx } from './cx';
import { Skeleton } from './Skeleton';
import s from './StatTile.module.css';

export interface StatTileProps {
  label: string;
  value: ReactNode;
  icon?: ReactNode;
  /** Variation en % (positive = hausse). */
  delta?: number;
  /** Interprétation de la hausse : « good » (ambre/vert) ou « bad » (rouge). */
  deltaGood?: 'up' | 'down';
  hint?: ReactNode;
  loading?: boolean;
  tone?: 'default' | 'accent';
}

export function StatTile({ label, value, icon, delta, deltaGood = 'up', hint, loading, tone = 'default' }: StatTileProps) {
  const good = delta === undefined ? undefined : deltaGood === 'up' ? delta >= 0 : delta <= 0;
  return (
    <div className={cx(s.tile, tone === 'accent' && s.accent)}>
      <div className={s.top}>
        <span className={s.label}>{label}</span>
        {icon && <span className={s.icon}>{icon}</span>}
      </div>
      <div className={s.value}>{loading ? <Skeleton width={96} height={32} /> : value}</div>
      <div className={s.foot}>
        {delta !== undefined && !loading && (
          <span className={cx(s.delta, good ? s.good : s.bad)}>
            {delta >= 0 ? <ArrowUpRight size={14} /> : <ArrowDownRight size={14} />}
            {Math.abs(delta)}%
          </span>
        )}
        {hint && <span className={s.hint}>{hint}</span>}
      </div>
    </div>
  );
}
